import { EmployeeSection } from '../../components/EmployeeSection';
import { Field, Input, Select } from '@welbe/design-system';
import { useEmployee } from '../../Employee.hooks';
import {
	INHERITANCE_RIGHTS_EXCLUSIVE_IDS,
	INHERITANCE_RIGHTS_OPTIONS,
} from '../../Employee.constants';
import { Controller } from 'react-hook-form';

export const InheritanceRights = ({
	errors,
	disabled,
}: {
	errors: string[];
	disabled?: boolean;
}) => {
	const { methods } = useEmployee();
	const { control, register } = methods;

	return (
		<EmployeeSection
			id="inheritance-rights"
			title="Derechohabiencia"
			description="Institución (es) del Sistema Nacional de Salud en la(s) cual(es) se encuentran afiliado el colaborador"
		>
			<Controller
				name="siresProfile.inheritanceRights"
				control={control}
				render={({ field }) => {
					const currentValue = (field.value as string[]) || [];
					const hasExclusive = currentValue.some((v) =>
						INHERITANCE_RIGHTS_EXCLUSIVE_IDS.includes(v),
					);
					const hasNonExclusive = currentValue.some(
						(v) => !INHERITANCE_RIGHTS_EXCLUSIVE_IDS.includes(v),
					);
					const filteredOptions = INHERITANCE_RIGHTS_OPTIONS.filter((opt) => {
						if (hasExclusive) return currentValue.includes(opt.id);
						if (hasNonExclusive)
							return !INHERITANCE_RIGHTS_EXCLUSIVE_IDS.includes(opt.id);
						return true;
					});

					return (
						<Select.Snippet
							usePortal
							required
							invalid={errors.includes('siresProfile') && !field.value?.length}
							label="Seleccionar institución (es)"
							placeholder="Selecciona la institución"
							showEmpty
							multiple
							readOnly={disabled}
							options={filteredOptions}
							value={(field.value as any) || []}
							onValueChange={(selected: any) => {
								field.onChange(selected.map((item: any) => item.id));
							}}
						/>
					);
				}}
			/>

			<Field.Root readOnly={disabled}>
				<Field.Label>Número de seguridad social</Field.Label>
				<Input
					placeholder="Escribe el número de seguridad social"
					{...register('socialSecurityNumber')}
				/>
			</Field.Root>
		</EmployeeSection>
	);
};
